import { useState, useEffect } from "react";
import Header from "../Header/Header";
import "./Landing.css";
import Button from "@mui/material/Button";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import why_rock_img1 from "../../assets/why_rock_img1.webp";
import why_rock_img2 from "../../assets/why_rock_img2.webp";
import why_rock_img3 from "../../assets/why_rock_img3.webp";
import why_rock_img4 from "../../assets/why_rock_img4.webp";
import works_img1 from "../../assets/works_img1.webp";
import works_img2 from "../../assets/works_img2.webp";
import works_img3 from "../../assets/works_img3.webp";
import works_img4 from "../../assets/works_img4.webp";
import works_img5 from "../../assets/works_img5.webp";
import works_img6 from "../../assets/works_img6.webp";
import rating_icon_img1 from "../../assets/rating_icon_img1.webp";
import rating_icon_img2 from "../../assets/rating_icon_img2.webp";
import rating_icon_img3 from "../../assets/rating_icon_img3.webp";
import rating_icon_img4 from "../../assets/rating_icon_img4.webp";
import rating_icon_img5 from "../../assets/rating_icon_img5.webp";
import review_prfo_img from "../../assets/review_prfo_img.webp";
import rev_green_star from "../../assets/rev_green_star.webp";
import quote_img from "../../assets/quote_img.webp";
import roadmap_img1 from "../../assets/roadmap_img1.webp";
import roadmap_img2 from "../../assets/roadmap_img2.webp";
import roadmap_img3 from "../../assets/roadmap_img3.webp";
import roadmap_img4 from "../../assets/roadmap_img4.webp";
import roadmap_img5 from "../../assets/roadmap_img5.webp";
import carousel_img1 from "../../assets/carousel-img1.webp";
import carousel_img2 from "../../assets/carousel_img2.webp";
import carousel_img3 from "../../assets/carousel_img3.webp";
import carousel_img4 from "../../assets/carousel_img4.webp";
import carousel_img5 from "../../assets/carousel_img5.webp";
import land_line_video from "../../assets/videos/land_line_video.gif";
import { FaStar } from "react-icons/fa";
import Spline from "@splinetool/react-spline";
import { GoArrowLeft } from "react-icons/go";
import { GoArrowRight } from "react-icons/go";
import { MdMyLocation } from "react-icons/md";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import { useNavigate } from "react-router-dom";

const Landing = () => {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState("right");
  const [address, setAddress] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedAddress = localStorage.getItem("userAddress");
    if (storedAddress) {
      setAddress(storedAddress);
    }
  }, []);
  const slides = [
    { id: 1, content: "Real Estate" },
    { id: 2, content: "Treasuries & Bonds" },
    { id: 3, content: "Private Credit" },
    { id: 4, content: "Commodities" },
    { id: 5, content: "Equities" },
    // { id: 5, content: "Stocks" },
  ];

  const nextSlide = () => {
    setDirection("right");
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setDirection("left");
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setDirection(index > current ? "right" : "left");
    setCurrent(index);
  };

  const itemsContent = [
    {
      id: 0,
      img: carousel_img1,
      title: "Real Estate",
      asstesTokenized: { value: "$120M", label: "in assets tokenized" },
      annualYield: { value: "19%", label: "average annual yield" },
      annualInvestors: { value: "29K", label: "active investors" },
      annualOnboard: { value: "18K", label: "properties onboarded" },
      buttonText: "Explore Now",
    },
    {
      id: 1,
      img: carousel_img2,
      title: "Treasuries & Bonds",
      asstesTokenized: { value: "$300M", label: "tokenized bills" },
      annualYield: { value: "4.5%", label: " annualized yield" },
      annualInvestors: { value: "5K", label: "investors onboard" },
      annualOnboard: { value: "200+", label: "bond issues supported" },
      buttonText: "Explore Now",
    },
    {
      id: 2,
      img: carousel_img3,
      title: "Private Credit / Loans",
      asstesTokenized: { value: "$250M", label: "in tokenized loans" },
      annualYield: { value: "11%", label: "annual yield" },
      annualInvestors: { value: "25K", label: "retail investors" },
      annualOnboard: { value: "1%", label: "default rate" },
      buttonText: "Explore Now",
    },
    {
      id: 3,
      img: carousel_img4,
      title: "Commodities",
      asstesTokenized: { value: "$20M", label: "commodity tokenized" },
      annualYield: { value: "7%", label: "blended yield" },
      annualInvestors: { value: "8K", label: "active users" },
      annualOnboard: { value: "6+", label: "different metals supported" },
      buttonText: "Explore Now",
    },
    {
      id: 4,
      img: carousel_img5,
      title: "Equities / Stoccks",
      asstesTokenized: { value: "$320M", label: "in tokenized stocks" },
      annualYield: { value: "19%", label: "ividend yield" },
      annualInvestors: { value: "18K", label: "investors engaged" },
      annualOnboard: { value: "120+", label: "listed companies" },
      buttonText: "Explore Now",
    },
  ];

  return (
    <div className="">
      <Header />
      <div className="main_page_wrp">
        <div className="ln-main-wrp">
          <div className="ln_hero_sectn">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xx-6">
                <div className="hero_lft_content">
                  <h6>Build with Assetly </h6>
                  <h3>The Leader in Real-World Asset Tokenization</h3>
                  <p>
                    Refine investing in real-world assets with our white label
                    product, the Polymath Capital Platform.
                  </p>
                  <div className="hero_btn_grup">
                    {address == null ? (
                      <button
                        className="tokenize_btn"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        <span>Tokenize Now</span>
                      </button>
                    ) : (
                      <button
                        className="tokenize_btn"
                        onClick={() => {
                          navigate("/dashboard");
                        }}
                      >
                        <span>Tokenize Now</span>
                      </button>
                    )}

                    <button
                      className="learnmore_btn"
                      onClick={() => {
                        navigate("/institution");
                      }}
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xx-6">
                <div className="spline_hero_3d">
                  {/* <Spline scene="https://prod.spline.design/SD6Z2SodqoobSaaC/scene.splinecode" /> */}
                  {/* <Spline scene="https://prod.spline.design/YZNogYbHHj947rXb/scene.splinecode" /> */}
                  {/* <Spline scene="https://prod.spline.design/YZNogYbHHj947rXb/scene.splinecode" /> */}
                </div>
              </div>
            </div>
          </div>

          <div className="ln_wrdiff_sectn">
            <div className="video_land_lines">
              <img src={land_line_video} alt="land_line_video" />
            </div>

            <div className="ln_wrdiff_cont">
              <h6>How we’re Different</h6>
              <h4>Bringing the World Onchain to Build a Borderless Economy.</h4>
              <p>
                Securitize is making real-world assets available to institutions
                and investors through tokenization, a process that registers
                ownership rights on the blockchain.
              </p>
              <div className="wrdiff_btn_grup">
                {address == null ? (
                  <button
                    className="started_btn"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <span>Get Started</span>
                  </button>
                ) : (
                  <button
                    className="started_btn"
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    <span>Get Started</span>
                  </button>
                )}

                <button
                  className="institions_btn"
                  onClick={() => {
                    navigate("/institution");
                  }}
                >
                  For Institutions <FaArrowUpRightFromSquare />
                </button>
              </div>
            </div>
          </div>

          <section className="ln_why_sectn">
            <h6>
              Why <span>Assetly?</span>
            </h6>
            <div className="ln_why_collton_card">
              <div className="collton_item card25pect">
                <span>$1B+</span>
                <h6>Assets Tokenized</h6>
                <p>
                  We've already tokenized over $1 billion in assets, from real
                  estate to rare collectibles.
                </p>
              </div>
              <div className="collton_item card25pect">
                <span>50+</span>
                <h6>Global Partners</h6>
                <p>
                  Our network spans over 50 trusted custodians, legal firms, and
                  DeFi platforms worldwide
                </p>
              </div>
              <div className="collton_item card50pect">
                <span>100K+</span>
                <h6>Active Investors</h6>
                <p>
                  Join a thriving community of over 100,000 investors worldwide,
                  from first-timers to institutions, all capitalizing on
                  tokenized assets.
                </p>
              </div>
              <div className="collton_item card50pect">
                <span>10%+</span>
                <h6>Average Yield</h6>
                <p>
                  {" "}
                  Earn juicy returns with average yields exceeding 10% through
                  staking, lending, or trading your tokenized assets in DeFi.
                </p>
              </div>
              <div className="collton_item card25pect">
                <span>24/7</span>
                <h6>Global Trading</h6>
                <p>
                  Trade your tokens anytime, anywhere, accessible across 190+
                  countries in our Market.
                </p>
              </div>
              <div className="collton_item card25pect">
                <span>99.9%</span>
                <h6>Uptime Guarantee</h6>
                <p>
                  Our blockchain infrastructure ensures near-perfect
                  reliability.
                </p>
              </div>
            </div>
          </section>

          <section className="ln_whyrock_sectn">
            <h6>
              Why Assetly <span>Rocks</span>
            </h6>
            <div className="row ln_whyrock_row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 ln_whyrock_col">
                <div className="ln_whyrock_contnt">
                  <div className="contnt_img">
                    <img src={why_rock_img1} alt="why_rock_img1" />
                  </div>
                  <div>
                    <h4>Skyrocketing Liquidity</h4>
                    <p>
                      Unlock the value of real estate, collectibles, or other
                      locked assets without selling them outright. Trade
                      globally, settle instantly, and access liquidity whenever
                      you need it.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 ln_whyrock_col">
                <div className="ln_whyrock_contnt">
                  <div className="contnt_img">
                    <img src={why_rock_img2} alt="why_rock_img2" />
                  </div>
                  <div>
                    <h4>Epic Yields</h4>
                    <p>
                      Put your tokens to work by staking or lending in DeFi and
                      earn up to 12% APY. Enjoy passive income streams backed by
                      secure, on-chain opportunities.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 ln_whyrock_col">
                <div className="ln_whyrock_contnt">
                  <div className="contnt_img">
                    <img src={why_rock_img3} alt="why_rock_img3" />
                  </div>
                  <div>
                    <h4>Anyone Can Invest</h4>
                    <p>
                      From $10 to millions, own premium assets without breaking
                      the bank. Fractional ownership lets anyone invest in real
                      estate, art, or bonds with the same ease as buying crypto.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 ln_whyrock_col">
                <div className="ln_whyrock_contnt">
                  <div className="contnt_img">
                    <img src={why_rock_img4} alt="why_rock_img4" />
                  </div>
                  <div>
                    <h4>Crystal Transparency</h4>
                    <p>
                      Every move is tracked on chain, so you always know what’s
                      up. Transparent ledgers give you real time visibility into
                      ownership, transfers, and yields with no hidden steps and
                      no blind spots.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="ln_wrkInvstr_sectn">
            <h6>
              How Assetly Works for <span>Investors </span>
            </h6>
            <p>
              From asset to blockchain in five electrifying steps. Here’s how
              you can tokenize, trade, and thrive with Tokenized World!
            </p>
            <div className="ln_wrkInvstr_collton_card">
              <div className="collton_item card50pect">
                <img src={works_img1} alt="works_img1" />
                <span>01</span>
                <h6>Connect Your Wallet</h6>
                <p>
                  Link your preferred crypto wallet (e.g., MetaMask, Coinbase
                  Wallet, WalletConnect) to securely access the Assetly
                  platform. Your assets stay in your control — we never hold
                  your private keys.
                </p>
              </div>
              <div className="collton_item card25pect">
                <img src={works_img2} alt="works_img2" />
                <span>02</span>
                <h6>Select Your Asset</h6>
                <p>
                  Explore a curated marketplace of tokenized real-world assets
                  across categories like real estate,commodities and more{" "}
                </p>
              </div>
              <div className="collton_item card25pect">
                <img src={works_img3} alt="works_img3" />
                <span>03</span>
                <h6>Review Asset Details</h6>
                <p>
                  Get full transparency before you invest. see asset valuations,
                  ownership records, legal audit reports
                </p>
              </div>
              <div className="collton_item card25pect">
                <img src={works_img4} alt="works_img4" />
                <span>04</span>
                <h6>Invest with Confidence</h6>
                <p>
                  Buy asset tokens directly using cryptocurrency or stablecoins
                  in Assetly 24/7.
                </p>
              </div>
              <div className="collton_item card25pect">
                <img src={works_img5} alt="works_img5" />
                <span>05</span>
                <h6>Trade on the Marketplace</h6>
                <p>
                  Enjoy liquidity and flexibility with Assetly’s built-in
                  marketplace. Buy, sell, or hold your tokens instantly with
                  global access.
                </p>
              </div>
              <div className="collton_item card50pect">
                <img src={works_img6} alt="works_img6" />
                <span>06</span>
                <h6>Manage Your Portfolio</h6>
                <p>
                  {" "}
                  Track your holdings, yields, and performance in real-time
                  through our intuitive dashboard. Set alerts, monitor trends,
                  and watch your investments grow, all in one place.
                </p>
              </div>
            </div>
          </section>

          <section className="ln_wolrdassets_sectn ln_realwporld_sectn">
            <h6>
              Real-World Assets <span>On-Chain </span>
            </h6>

            <div className="land_tab_main">
              {slides.map((slide, index) => (
                <button
                  key={slide.id}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full ${
                    current === index ? "active" : "no-active"
                  } land_tab_item`}
                >
                  {slide.content}
                </button>
              ))}
            </div>

            <div className="carousel_content_wrp">
              {itemsContent.map((item, index) => {
                return (
                  //   ${
                  // index === current.id
                  //   ? "translate-x-0 opacity-100"
                  //   : direction === "right"
                  //   ? "translate-x-full opacity-0"
                  //   : "-translate-x-full opacity-0"
                  //       }
                  current == item.id ? (
                    <div
                      // className={`${current == item.id ? 'active_carousel' : 'no_active_carousel'} carsl-item-main`}
                      className={`carsl-item-main absolute w-full h-full flex items-center justify-center text-xl font-semibold transition-transform duration-500 ease-in-out 
                      
                      ${
                        direction === "right"
                          ? "act_caros_right"
                          : "act_caros_left"
                      }
                      ${
                        current == item.id
                          ? "active_carousel"
                          : "no_active_carousel"
                      }
                      `}
                    >
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                          <div className="carousel_img">
                            <img src={item.img} alt="carousel_img" />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                          <div className="carousel_content">
                            <h5>{item.title}</h5>
                            <ul>
                              <li>
                                <span>{item.asstesTokenized.value}</span>
                                <p>{item.asstesTokenized.label}</p>
                              </li>
                              <li>
                                <span>{item.annualYield.value}</span>
                                <p>{item.annualYield.label}</p>
                              </li>
                              <li>
                                <span>{item.annualInvestors.value}</span>
                                <p>{item.annualInvestors.label}</p>
                              </li>
                              <li>
                                <span>{item.annualOnboard.value}</span>
                                <p>{item.annualOnboard.label}</p>
                              </li>
                            </ul>

                            <button
                              className="carousel_btn"
                              onClick={() => {
                                navigate("/market");
                              }}
                            >
                              {item.buttonText}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null
                );
              })}
            </div>

            <div className="caruse_btn_wrp">
              <button
                onClick={() => {
                  navigate("/market");
                }}
              >
                See More Assets
              </button>
              <div className="caruse_btn_grp">
                <button onClick={prevSlide}>
                  <GoArrowLeft />
                </button>
                <button onClick={nextSlide}>
                  <GoArrowRight />
                </button>
              </div>
            </div>
          </section>

          <section className="ln_wrkInvstr_sectn">
            <h6>
              Our Epic <span>Roadmap </span>
            </h6>
            <p>
              Our vision is to revolutionize real-world asset tokenization.
              Here’s our plan to make it happen.
            </p>

            <ul className="roadmap_list_main">
              <li>
                <div className="roadmap_img">
                  <img src={roadmap_img1} alt="roadmap_img" />
                </div>
                <div className="roadmap_list_content">
                  <h4>2025</h4>
                  <h6>Platform Launch</h6>
                </div>
                <p>
                  <img src={quote_img} alt="quote_img" className="quote_img" />
                  The official launch of Assetly with core features for
                  tokenizing real-world assets and enabling secure investments.
                </p>
              </li>
              <li>
                <div className="roadmap_img">
                  <img src={roadmap_img2} alt="roadmap_img" />
                </div>
                <div className="roadmap_list_content">
                  <h4>2025</h4>
                  <h6>Expanded Asset Classes</h6>
                </div>
                <p>
                  <img src={quote_img} alt="quote_img" className="quote_img" />
                  Add new categories such as fine art, collectibles, music
                  rights, and commodities, giving investors more diverse
                  opportunities.
                </p>
              </li>
              <li>
                <div className="roadmap_img">
                  <img src={roadmap_img3} alt="roadmap_img" />
                </div>
                <div className="roadmap_list_content">
                  <h4>2026</h4>
                  <h6>Global Expansion</h6>
                </div>
                <p>
                  <img src={quote_img} alt="quote_img" className="quote_img" />
                  Scale into international markets with support for multiple
                  currencies, local regulations, and regional compliance
                  frameworks.
                </p>
              </li>
              <li>
                <div className="roadmap_img">
                  <img src={roadmap_img4} alt="roadmap_img" />
                </div>
                <div className="roadmap_list_content">
                  <h4>2026</h4>
                  <h6>DeFi Integration</h6>
                </div>
                <p>
                  <img src={quote_img} alt="quote_img" className="quote_img" />
                  Connect Assetly with leading DeFi protocols, allowing users to
                  lend, borrow, stake, and earn yields on tokenized assets.
                </p>
              </li>
              <li>
                <div className="roadmap_img">
                  <img src={roadmap_img5} alt="roadmap_img" />
                </div>
                <div className="roadmap_list_content">
                  <h4>2026</h4>
                  <h6>AI-Powered Insights</h6>
                </div>
                <p>
                  <img src={quote_img} alt="quote_img" className="quote_img" />
                  Introduce AI-driven analytics for asset valuation, risk
                  assessment, market forecasting, and personalized investment
                  recommendations.
                </p>
              </li>
            </ul>
          </section>

          <section className="reviews_sectn">
            <h6>
              Our rating based on{" "}
              <span>
                1,200+ <br></br>{" "}
              </span>{" "}
              verified investor reviews
            </h6>
            <div className="row reviews_sectn_row">
              <div className="col-12 col-sm-12 cl-md-8 col-lg-8 col-xl-8 col-xxl-8">
                <div className="reviews_wrp">
                  <div className="revies_contnt">
                    <div className="revies_star_wrp">
                      <h5>5.0</h5>
                      <div className="revies_star">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                      </div>
                    </div>
                    <ul className="revies_ul_wrp">
                      <li>
                        <div className="review_icon">
                          <img src={rating_icon_img1} alt="rating_icon_img1" />
                        </div>
                        Real Estate / Private Equity
                      </li>
                      <li>
                        <div className="review_icon">
                          <img src={rating_icon_img2} alt="rating_icon_img2" />
                        </div>
                        San Francisco, California
                      </li>
                      <li>
                        <div className="review_icon">
                          <img src={rating_icon_img3} alt="rating_icon_img3" />
                        </div>
                        10,000+ active members
                      </li>
                      <li>
                        <div className="review_icon">
                          <img src={rating_icon_img4} alt="rating_icon_img4" />
                        </div>
                        $500M+ tokenized
                      </li>
                      <li>
                        <div className="review_icon">
                          <img src={rating_icon_img5} alt="rating_icon_img5" />
                        </div>
                        May, 2022 – Ongoing
                      </li>
                    </ul>
                  </div>
                  <div className="review_profle_wrp">
                    <div className="review_profle_cnt">
                      <div className="review_profle_img">
                        <img src={review_prfo_img} alt="review_prfo_img" />
                      </div>
                      <h6>— David Lee | Lead Analyst</h6>
                    </div>
                    <div className="review_profle_descpt">
                      <p>
                        "Assetly made investing in real estate simple, secure,
                        and profitable. I finally feel in control of my
                        portfolio."
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 cl-md-4 col-lg-4 col-xl-4 col-xxl-4">
                <div className="rate_white_crd">
                  <div className="top_rate_cnt">
                    <div className="top_rate_img_wrp">
                      <div className="top_rate_img">
                        <img src={rev_green_star} alt="rev_green_star" />
                      </div>
                      <h5>Trustpilot</h5>
                    </div>
                    <Link>View Profile</Link>
                  </div>
                  <div className="revies_whitecrd_wrp">
                    <h5>4.9</h5>
                    <div className="revies_star">
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      <FaStar />
                    </div>
                  </div>
                  <ul className="revie-points">
                    <li>Secure transactions</li>
                    <li>Transparent reporting</li>
                    <li>Easy onboarding</li>
                    <li>Strong returns</li>
                    <li>Excellent support</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="Faq_sectn">
            <h6>
              FAQ/ <span>Support </span>
            </h6>
            <div className="row Faq_sectn_row">
              <div className="col-12 cl-sm-12 col-md-6 col-lg-6 col-xl-6 Faq_sectn_col1">
                <div
                  className="accordion accordion-flush"
                  id="accordionFlushExample"
                >
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOne">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        What are Real World Assets?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseOne"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingOne"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        RWAs are physical or financial assets like real estate
                        or bonds turned into blockchain tokens for easy trading
                        and ownership.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        How do I start?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        Sign up, complete KYC, and tokenize your assets in a few
                        clicks. It’s that easy!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseThree"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        What assets can I tokenize?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingThree"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        From real estate and treasuries to art, collectibles,
                        and carbon credits — we support a wide range of asset
                        classes.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFour"
                        aria-expanded="false"
                        aria-controls="flush-collapseFour"
                      >
                        What currencies do you accept?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingFour"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        You can start with stablecoins like USDC/USDT or connect
                        your bank account for fiat deposits.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 cl-sm-12 col-md-6 col-lg-6 col-xl-6 Faq_sectn_col2">
                <div
                  className="accordion accordion-flush"
                  id="accordionFlushExample2"
                >
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFive"
                        aria-expanded="false"
                        aria-controls="flush-collapseFive"
                      >
                        What are Real World Assets?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingFive"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                        RWAs are physical or financial assets like real estate
                        or bonds turned into blockchain tokens for easy trading
                        and ownership.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseSix"
                        aria-expanded="false"
                        aria-controls="flush-collapseSix"
                      >
                        How do I start?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingSix"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                        Sign up, complete KYC, and tokenize your assets in a few
                        clicks. It’s that easy!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingSeven">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseSeven"
                        aria-expanded="false"
                        aria-controls="flush-collapseEight"
                      >
                        What assets can I tokenize?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseSeven"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingSeven"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                        From real estate and treasuries to art, collectibles,
                        and carbon credits — we support a wide range of asset
                        classes.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingEight">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseEight"
                        aria-expanded="false"
                        aria-controls="flush-collapseEight"
                      >
                        What currencies do you accept?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseEight"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingEight"
                      data-bs-parent="#accordionFlushExample2"
                    >
                      <div className="accordion-body">
                        You can start with stablecoins like USDC/USDT or connect
                        your bank account for fiat deposits.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="join_assetly_section">
            <h6>Join the Assetly Revolution!</h6>
            <p>
              Experience the future of finance where real estate, art, bonds,
              and more come alive on chain. Redefine asset ownership, unlock
              global opportunities, and be part of the next big wave in
              Web3.Link your wallet for exclusive early access and start
              building your portfolio of real world assets today.
            </p>
            <div className="join_assetly_btn_grup">
              {address == null ? (
                <button
                  className="started_btn"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  <span>Get Started</span>
                </button>
              ) : (
                <button
                  className="started_btn"
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                >
                  <span>Get Started</span>
                </button>
              )}

              <button
                className="institions_btn"
                onClick={() => {
                  navigate("/institution");
                }}
              >
                For Institutions <FaArrowUpRightFromSquare />
              </button>
            </div>
          </section>
        </div>
        <div className="mt-5 landing_footer">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Landing;
